import PropTypes from "prop-types";
import { List, Stack } from "@mui/material";
import { useLocales } from "../../../locales";
import { StyledSubheader } from "./styles";
import NavList from "./NavList";
import { useAuthContext } from "src/auth/useAuthContext";

NavSectionVertical.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
};

export default function NavSectionVertical({ data, sx, ...other }) {
  const { translate } = useLocales();
  const { user } = useAuthContext();

  let filteredData = data.map((group) => {
    let items = group.items;

    if (!user?.permissions?.canViewDashboard) {
      items = items.filter((item) => item.title !== "dashboard");
    }
    if (!user?.permissions?.canViewStaff) {
      items = items.filter((item) => item.title !== "staff");
    }
    if (!user?.permissions?.canViewStock) {
      items = items.filter((item) => item.title !== "stock");
    }
    if (!user?.permissions?.canViewLiveStock) {
      items = items.filter((item) => item.title !== "Live stock");
    }
    if (!user?.permissions?.canViewAdjustment) {
      items = items.filter((item) => item.title !== "Adjustment");
    }
    if (!user?.permissions?.canViewItem) {
      items = items.filter((item) => item.title !== "Item");
    }
    if (!user?.permissions?.canAccessReports) {
      items = items.filter((item) => item.title !== "report");
    }
    if (!user?.permissions?.canViewPurchseOrder) {
      items = items.filter((item) => item.title !== "Purchase Order");
    }
    if (!user?.permissions?.canViewSuppliers) {
      items = items.filter((item) => item.title !== "suppliers");
    }
    if (!user?.permissions?.canViewPurchseOrderInvoices) {
      items = items.filter((item) => item.title !== "Invoice");
    }
    return { ...group, items };
  });

  return (
    <Stack sx={sx} {...other}>
      {filteredData.map((group) => {
        const key = group.subheader || group.items[0].title;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>}

            {group.items.map((list, index) => (
              <NavList key={list.title + list[index]} data={list} depth={1} hasChild={!!list.children} />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}
